import React, { FC } from 'react';
import { Flex, Container } from 'roo-ui/components';
import { AcknowledgementOfCountry } from './AcknowledgementOfCountry';
import { TermsAndConditions } from './TermsAndConditions';
import { ScrollToTop } from './ScrollToTop';
import { Links } from './Links';
import { FooterWrapper } from './primitives';
import { LinkOptions, LinkList } from '../../lib/types';
import { theme } from '../../lib/theme';

export interface FooterProps {
  landingPageUrl: string;
  disclaimerLinks: LinkOptions[];
  abn: string;
  footerLogoSrc: string;
  footerLogoLabel: string;
  links: LinkList[];
  backgroundColor?: string;
  onInteraction?: Function;
  queryString?: string;
}

export const Footer: FC<FooterProps> = ({
  landingPageUrl,
  disclaimerLinks,
  abn,
  footerLogoSrc,
  footerLogoLabel,
  links,
  backgroundColor = theme.colors.greys.charcoal,
  onInteraction = () => {},
  queryString,
}) => (
  <FooterWrapper backgroundColor={backgroundColor}>
    <Container>
      <ScrollToTop
        landingPageUrl={landingPageUrl}
        footerLogoSrc={footerLogoSrc}
        footerLogoLabel={footerLogoLabel}
      />

      <Flex flexWrap="wrap">
        {links.map((linkProps, index) => (
          <Links
            key={`footer-list-${index}`}
            onInteraction={onInteraction}
            queryString={queryString}
            {...linkProps}
          />
        ))}
      </Flex>

      <AcknowledgementOfCountry />

      <TermsAndConditions disclaimerLinks={disclaimerLinks} abn={abn} />
    </Container>
  </FooterWrapper>
);
